import React from "react";
import styles from "./AsideRow.module.css";

export interface AsideRowProps {
  /** Narrow left column — typically a `ListCard`. */
  aside: React.ReactNode;
  /** Main column, three times the aside's width. */
  children: React.ReactNode;
}

/**
 * A row pairing a narrow aside with wide main content. Both slots are the
 * grid's own children, so each stretches to the row's height — an aside card
 * ends level with a table beside it. Stacks under a narrow breakpoint.
 */
const AsideRow = ({ aside, children }: AsideRowProps): React.ReactElement => {
  return (
    <div className={styles.row}>
      {aside}
      {children}
    </div>
  );
};

export default AsideRow;
